import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NewsCard from '../components/Home/NewsCard';
import Sidebar from '../components/Home/Sidebar';
import { useApp } from '../context/AppContext';

const CategoryPage = () => {
    const { category } = useParams();
    const { articles } = useApp();
    const [categoryArticles, setCategoryArticles] = useState([]);
    const [displayCount, setDisplayCount] = useState(9);

    useEffect(() => {
        const filtered = articles.filter(a =>
            a.status === 'live' &&
            (a.category.toLowerCase() === category.toLowerCase() ||
                a.section.toLowerCase() === category.toLowerCase())
        );
        setCategoryArticles(filtered);
        setDisplayCount(9);
    }, [category, articles]);

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
    const displayArticles = categoryArticles.slice(0, displayCount);

    return (
        <div className="page">
            <div className="two-col">
                <div>
                    <div className="section-title">{capitalize(category)} News</div>
                    <div className="three-col">
                        {displayArticles.map(article => (
                            <NewsCard key={article._id} article={article} />
                        ))}
                    </div>
                    {displayCount < categoryArticles.length && (
                        <div style={{ textAlign: 'center', marginTop: '24px' }}>
                            <button className="btn btn-outline" onClick={() => setDisplayCount(displayCount + 6)}>Load More →</button>
                        </div>
                    )}
                </div>
                <div>
                    <Sidebar articles={articles} />
                </div>
            </div>
        </div>
    );
};

export default CategoryPage;